module.exports = __webpack_public_path__ + "static/media/aurora-removebg-preview__1_-removebg-preview.60c9802b.png";